/*
  Enkindle reveal-on-load.

  The theme's own helper (window.PXUTheme.animation.init) binds jQuery Waypoints to
  [data-scroll-class] and only adds the animation class on a scroll/waypoint trigger.
  Anything already inside the viewport when the page loads therefore never fires and
  sits at the animation's initial opacity: 0 — so on a tall monitor the section under
  the hero renders as blank space until the visitor scrolls.

  This sweeps everything currently in view and reveals it immediately. Idempotent, and
  it leaves below-the-fold elements to the theme's waypoints as normal.
*/
(function () {
  if (window.__enkRevealInit) { return; }
  window.__enkRevealInit = true;

  function revealInView() {
    var els = document.querySelectorAll('[data-scroll-class]:not(.animated)');
    if (!els.length) { return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      // Any part of it visible. Genuinely below-fold elements are left to the theme waypoints.
      if (r.top < vh && r.bottom > 0) {
        var cls = el.getAttribute('data-scroll-class');
        el.classList.add('animated');
        if (cls) { el.classList.add(cls); }
      }
    }
  }

  function run() {
    revealInView();
    // Late images, web fonts and app blocks all shift layout after first paint,
    // which can pull another section into view. Sweep again rather than guess.
    setTimeout(revealInView, 350);
    setTimeout(revealInView, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', revealInView);
  window.addEventListener('resize', revealInView);
  // Fires when a section is re-rendered in the theme customiser.
  document.addEventListener('shopify:section:load', revealInView);
})();